import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GatewayService, type CreateClientPayload } from "../api/gateway.service";
import type { Client } from "@shared-types";

/** State and action returned by {@link useCreateClient}. */
export interface UseCreateClientReturn {
    /** Create a client; resolves with the created record. */
    createClient: (clientData: CreateClientPayload) => Promise<Client>;
    loading: boolean;
    error: Error | null;
    data: Client | null;
}

/** Create a client and invalidate the cached clients list on success. */
export const useCreateClient = (): UseCreateClientReturn => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: (clientData: CreateClientPayload) => GatewayService.createClient(clientData),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: ["gateway", "clients"] }),
    });
    return {
        createClient: (clientData) => mutation.mutateAsync(clientData),
        loading: mutation.isPending,
        error: mutation.error,
        data: mutation.data ?? null,
    };
};
